import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

// 解决 Vue-Router 3.1.0+ 版本在重复跳转同一路由时的报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Navigation cancelled')) {
      throw err
    }
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Navigation cancelled')) {
      throw err
    }
  })
}

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/userManager',
    name: 'UserManager',
    component: () => import('../views/UserManager.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/select-shitang',
    name: 'SelectShitang',
    component: () => import('../views/SelectShitang.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/shitang',
    name: 'Shitang',
    component: () => import('../views/Shitang.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/niuniu-growth',
    name: 'NiuniuGrowthTree',
    component: () => import('../views/NiuniuGrowthTree.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/lounge',
    name: 'Lounge',
    component: () => import('../views/Lounge.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/game',
    name: 'Game',
    component: () => import('../views/Game.vue'),
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const isGuest = localStorage.getItem('isGuest')
  // 如果页面需要权限
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 如果没有登录标记（既不是普通用户也不是游客）
    if (isGuest === null) {
      alert('请先选择登录方式或以游客身份进入')
      next('/')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
